const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£',
  AED: 'AED ',
  SGD: 'S$',
  AUD: 'A$',
  CAD: 'CA$',
};

export const getCurrencySymbol = (code) => CURRENCY_SYMBOLS[code] || code || '₹';

// India calls it GST, and calling it that anywhere else is simply wrong.
// Mirrors tax_label_for() in leads_management/proposal_pricing.py.
export const taxLabel = (code) => ((code || 'INR') === 'INR' ? 'GST' : 'Tax');

// Compact money for dashboards/tiles: Indian units (k/L/Cr) for INR, k/M/B
// for every other currency.
export const compactCurrency = (value, code) => {
  const n = Number(value || 0);
  const sym = getCurrencySymbol(code);
  const abs = Math.abs(n);
  if ((code || 'INR') === 'INR') {
    if (abs >= 1e7) return `${sym}${(n / 1e7).toFixed(1)}Cr`;
    if (abs >= 1e5) return `${sym}${(n / 1e5).toFixed(1)}L`;
    if (abs >= 1e3) return `${sym}${(n / 1e3).toFixed(1)}k`;
    return `${sym}${Math.round(n)}`;
  }
  if (abs >= 1e9) return `${sym}${(n / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${sym}${(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `${sym}${(n / 1e3).toFixed(1)}k`;
  return `${sym}${Math.round(n)}`;
};

// Full-precision money with the right digit grouping for the currency.
export const formatMoney = (value, code, decimals = 0) => {
  const n = Number(value || 0);
  const locale = (code || 'INR') === 'INR' ? 'en-IN' : 'en-US';
  return `${getCurrencySymbol(code)}${n.toLocaleString(locale, {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  })}`;
};
